// @flow

import AutoSelect from './AutoSelect'

export default AutoSelect
